module.exports = __webpack_public_path__ + "img/airners-logo-white.e54f0960.svg";